import React from 'react';

const Loader = () => {
  return <div id="loader" />;
};

export default Loader;
